import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { resetCampaignEditorErrors } from 'state/error'
import { Route, Redirect, RouteComponentProps } from 'react-router-dom'
import Editor from './Editor'
import Template from './Template'

export enum EDITOR_ROUTE_ENUM {
    EDIT = 'edit',
    VIEW = 'view',
}

export const ViewTypeContext = React.createContext(EDITOR_ROUTE_ENUM.VIEW)

const Campaign: React.FC<RouteComponentProps> = ({ match, location }) => {
    const prefix = match.path
    const dispatch = useDispatch()
    const currentLocation = location.pathname
        .replace(prefix, '')
        .replace('/edit/', '')
        .replace('/view/', '')
        .replace('/template/', '')

    useEffect(() => {
        return () => {
            dispatch(resetCampaignEditorErrors())
        }
    }, [])

    if (
        ![
            'registration',
            'tasks',
            'publish',
            'payment',
            'templateSelector',
            'templateDetail',
            'templateSummary',
        ].includes(currentLocation)
    )
        return <Redirect to="/404" />

    return (
        <>
            <Route exact path={prefix} render={(): JSX.Element => <Redirect to={`${prefix}/edit/registration`} />} />
            <Route path={`${prefix}/template`} component={Template} />
            <ViewTypeContext.Provider value={EDITOR_ROUTE_ENUM.EDIT}>
                <Route path={`${prefix}/edit`} component={Editor} />
            </ViewTypeContext.Provider>
            <ViewTypeContext.Provider value={EDITOR_ROUTE_ENUM.VIEW}>
                <Route path={`${prefix}/view`} component={Editor} />
            </ViewTypeContext.Provider>
        </>
    )
}

export default Campaign
